import moment from 'moment'

import { isPmsSyncLastInfoStale } from './pmsSyncDataRecency'

/**
 * Row status for Health Check PMS tab (left bar + alert/warning/green filters).
 * @param {object} row
 * @returns {'alert' | 'warning' | 'green'}
 */
export function calculatePmsHealthCheckRowStatus(row) {
  const {
    pmsSyncIsConnected,
    isAllReportHealthy,
    pmsSyncTotalReportsReceivedInLast48Hours,
    isHavingProblems,
    isDisabled,
    pmsSyncLastInfoReceivedOn
  } = row

  const fourteenDaysAgo = moment().subtract(14, 'days')
  const notSyncedFor14Days =
    isDisabled &&
    pmsSyncLastInfoReceivedOn &&
    moment(pmsSyncLastInfoReceivedOn).isBefore(fourteenDaysAgo)

  if (pmsSyncIsConnected === false) {
    return 'alert'
  }

  if (isHavingProblems === true) {
    return 'alert'
  }

  if (notSyncedFor14Days) {
    return 'alert'
  }

  if (!isDisabled && isPmsSyncLastInfoStale(pmsSyncLastInfoReceivedOn)) {
    return 'alert'
  }

  if (
    isAllReportHealthy !== true &&
    (pmsSyncTotalReportsReceivedInLast48Hours === undefined ||
      pmsSyncTotalReportsReceivedInLast48Hours === 0)
  ) {
    return 'warning'
  }

  if (!isDisabled && isAllReportHealthy === true) {
    return 'green'
  }

  if (
    !isDisabled &&
    pmsSyncTotalReportsReceivedInLast48Hours !== undefined &&
    pmsSyncTotalReportsReceivedInLast48Hours > 0
  ) {
    return 'green'
  }

  return 'warning'
}

/**
 * @param {object} row
 * @returns {string}
 */
export function getPmsHealthCheckRowStatusExplanation(row) {
  const {
    pmsSyncIsConnected,
    isAllReportHealthy,
    pmsSyncTotalReportsReceivedInLast48Hours,
    isHavingProblems,
    isDisabled,
    pmsSyncLastInfoReceivedOn
  } = row

  const fourteenDaysAgo = moment().subtract(14, 'days')
  const notSyncedFor14Days =
    isDisabled &&
    pmsSyncLastInfoReceivedOn &&
    moment(pmsSyncLastInfoReceivedOn).isBefore(fourteenDaysAgo)

  const status = calculatePmsHealthCheckRowStatus(row)
  const reasons = []

  if (status === 'alert') {
    if (pmsSyncIsConnected === false) {
      reasons.push('PMS not connected')
    }
    if (isHavingProblems === true) {
      reasons.push('PMS sync having problems')
    }
    if (notSyncedFor14Days) {
      reasons.push('Not synced for 14+ days and turned off')
    }
    if (!isDisabled && isPmsSyncLastInfoStale(pmsSyncLastInfoReceivedOn)) {
      reasons.push('No PMS data received in the last 2 days')
    }
  } else if (status === 'warning') {
    if (
      isAllReportHealthy !== true &&
      (pmsSyncTotalReportsReceivedInLast48Hours === undefined ||
        pmsSyncTotalReportsReceivedInLast48Hours === 0)
    ) {
      reasons.push('Partially working - not all reports healthy and no reports in last 48h')
    }
  } else if (status === 'green') {
    reasons.push('PMS connected and working properly')
    if (isAllReportHealthy === true) {
      reasons.push('All reports healthy')
    } else if (pmsSyncTotalReportsReceivedInLast48Hours > 0) {
      reasons.push(`${pmsSyncTotalReportsReceivedInLast48Hours} reports received in last 48h`)
    }
  }

  return reasons.length > 0 ? reasons.join(' • ') : 'Status: ' + status
}
